import Vue from 'vue';
import { createAuth0Client } from '@auth0/auth0-spa-js';
import {mapActions} from "vuex";
import store from '../store/index'
import {HTTP} from "@/utils/http";

/** Define a default action to perform after authentication */
const DEFAULT_REDIRECT_CALLBACK = () =>
    window.history.replaceState({}, document.title, window.location.pathname);

let instance;
const ACCESS_TOKEN_KEY = 'accessToken';
/** Returns the current instance of the SDK */
export const getInstance = () => instance;

/** Creates an instance of the Auth0 SDK. If one has already been created, it returns that instance */
export const useAuth0 = ({
                             onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
                             redirectUri = window.location.origin,
                             ...options
                         }) => {
    if (instance) return instance;

    // The 'instance' is simply a Vue object
    instance = new Vue({
        data() {
            return {
                loading: true,
                isAuthenticated: false,
                user: {},
                auth0Client: null,
                token: null,
                popupOpen: false,
                error: null
            };
        },
        methods: {
            ...mapActions(["authenticate"]),
            /** Authenticates the user using a popup window */
            async loginWithPopup(options, config) {
                console.log('loginWithPopup');
                this.popupOpen = true;

                try {
                    await this.auth0Client.loginWithPopup(options, config);
                    this.user = await this.auth0Client.getUser();
                    this.isAuthenticated = await this.auth0Client.isAuthenticated();
                    this.error = null;
                } catch (e) {
                    this.error = e;
                    // eslint-disable-next-line
                    console.log(e);
                } finally {
                    this.popupOpen = false;
                }

                this.user = await this.auth0Client.getUser();
                this.isAuthenticated = true;
            },
            /** Handles the callback when logging in using a redirect */
            async handleRedirectCallback() {
                this.loading = true;
                try {
                    await this.auth0Client.handleRedirectCallback();
                    this.user = await this.auth0Client.getUser();
                    this.isAuthenticated = true;
                    this.error = null;
                } catch (e) {
                    this.error = e;
                    console.log(this.error)
                } finally {
                    this.loading = false;
                }
            },
            /** Authenticates the user using the redirect method */
            loginWithRedirect(o) {
                console.log('loginWithRedirect')
                return  this.auth0Client.loginWithRedirect(o);
            },
            /** Returns all the claims present in the ID token */
            getIdTokenClaims(o) {
                return this.auth0Client.getIdTokenClaims(o);
            },
            /** Returns the access token. If the token is invalid or missing, a new one is retrieved */
            getTokenSilently(o) {
                return this.auth0Client.getTokenSilently(o);
            },
            /** Gets the access token using a popup window */

            getTokenWithPopup(o) {
                return this.auth0Client.getTokenWithPopup(o);
            },
            /** Logs the user out and removes their session on the authorization server */
            logout(o) {
                return this.auth0Client.logout(o);
            }
        },
        /** Use this lifecycle method to instantiate the SDK client */
        async created() {
            console.log('created')
            // Create a new instance of the SDK client using members of the given options object
            this.auth0Client = await createAuth0Client({
                ...options,
                authorizationParams: {
                    redirect_uri: window.location.origin,
                    logo:"https://dsmanager.storever.com/content/images/logo-auth.png",
                    responseType:"token id_token",
                    audience:"https://api.storever.com/",
                    scope:"openid profile email",
                }
            });
            try {
                console.log('try')
                // If the user is returning to the app after authentication..
                if (
                    window.location.search.includes('code=') &&
                    window.location.search.includes('state=')
                ) {
                    console.log('try')
                    // handle the redirect and retrieve tokens
                    const { appState } = await this.auth0Client.handleRedirectCallback();
                    console.log('try if if')
                    this.error = null;

                    // Notify subscribers that the redirect callback has happened, passing the appState
                    // (useful for retrieving any pre-authentication state)
                    onRedirectCallback(appState);
                }
            } catch (e) {
                this.error = e;
                console.log(this.error)
            } finally {

                console.log('finally')
                HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN_KEY);
                HTTP.interceptors.request.use(config => config);
                //response INTERCEPTOR
                HTTP.interceptors.response.use(response => {
                    console.log(response)
                    return response;
                }, err => {
                     console.log(err)
                     console.log( JSON.stringify(err).search('Network Error'))
                    //Error: Network Error
                    // error occurred
                    if ( typeof  err === 'object'   && JSON.stringify(err).search('Network Error') !== -1  && err.config.url !== "api/parameters/styles" && err.config.url !== "api/parameters/targets") {
                        console.log('logout')
                        localStorage.removeItem(ACCESS_TOKEN_KEY);
                        localStorage.removeItem('logging_user_email');
                        localStorage.removeItem('logging_user_name');
                        HTTP.defaults.headers.common['Authorization'] = null;
                        this.auth0Client.logout({logoutParams:{returnTo: window.location.origin}});

                    }
                    // error occurred
                    const error = err.response;
                    const originalRequest = error.config;

                    // if (error.status === 403  && err.config.url !== "api/parameters/styles" && err.config.url !== "api/parameters/targets") {
                    //     console.log('logout')
                    //     localStorage.removeItem(ACCESS_TOKEN_KEY);
                    //     localStorage.removeItem('logging_user_email');
                    //     localStorage.removeItem('logging_user_name');
                    //     HTTP.defaults.headers.common['Authorization'] = null;
                    //     this.auth0Client.logout({logoutParams:{returnTo: window.location.origin}});
                    //
                    // }

                    if (error.status === 400 && originalRequest && !originalRequest.__isRetryRequest) {

                        // store.dispatch('Toasts/addToast', {
                        //     title: 'Error occurred',
                        //     message: error.data.errors[0].message,
                        //     type: 'danger'
                        // });
                        //
                        // // if user comes with a wrong stationId, log out and redirect it to login page
                        // if(error.data.errors[0].message === 'Station not found'){
                        //     store.commit('logout');
                        // }
                    }

                    if (error.status === 401 && originalRequest && !originalRequest.__isRetryRequest) {
                        if(error.data.errors[0].message !== 'Station not found'){
                            store.dispatch('Toasts/addToast', {
                                title: 'You are disconnected',
                                message: 'Redirect to login page...',
                                type: 'primary',
                                //delay: 1500
                            });
                            store.commit('logout');
                        }
                    }

                    if (error.status === 500 && originalRequest && !originalRequest.__isRetryRequest) {

                        console.log('error 500: ', error);
                        store.dispatch('Toasts/addToast', {
                            title: 'Internal server error',
                            message:`${error.statusText} - Request api ${originalRequest.url}`,
                            type: 'danger'
                        });
                    }

                    return Promise.reject(err)
                })
                try {
                    this.token = await this.auth0Client.getTokenSilently()
                    this.isAuthenticated = await this.auth0Client.isAuthenticated();
                    this.user = await this.auth0Client.getUser();
                    this.loading = false;
                    console.log(this.user)
                    if ( this.token && this.user && this.user.email ){
                        store.dispatch('authenticate' ,  { 'user' : {'email': this.user.email , 'name' : this.user.family_name + ' ' + this.user.given_name }, 'token': this.token} );
                        console.log(this.token)
                    }
                } catch (e) {
                    if (localStorage.getItem(ACCESS_TOKEN_KEY) !== null  && localStorage.getItem('logging_user_email')  !== null){
                        store.dispatch('authenticate' ,{ 'user' :
                                {'email': localStorage.getItem('logging_user_email') ,
                                 'name' : localStorage.getItem('logging_user_name') } ,
                                 'token': localStorage.getItem(ACCESS_TOKEN_KEY) } );
                        this.isAuthenticated = true;
                    }
                    else
                        if (e.error === 'login_required' || e.error === 'consent_required' && this.token === null) {
                        console.log('finally if' ,e.error)
                        // console.log('finally if' , await this.auth0Client.getTokenSilently())
                        this.loginWithRedirect();
                    }
                }


            }
        }
    });

    return instance;
};

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const Auth0Plugin = {
    install(Vue, options) {
        const auth = useAuth0(options)

        Vue.$auth = auth // global property
        Vue.prototype.$auth = auth // instance property
    }
}

